import React from 'react';
import { NavLink } from 'react-router-dom';
import {
    Dashboard as DashboardIcon,
    People as PeopleIcon,
    BarChart as ReportsIcon,
    Assignment as FollowUpIcon,
    ReportProblem as IssueIcon,
    AdminPanelSettings as AdminIcon,
    EventAvailable as VisitIcon,
    Schedule as HoursIcon,
    Campaign as NoticeIcon,
} from '@mui/icons-material';
import {
    StyledList,
    StyledLink,
    StyledIcon,
    StyledText,
    StyledListItem,
} from './styles';
import { useAuth } from '../../../context/AuthContext';

function DrawerList() {
    /* VARIABLE DECELERATION
    -------------------------------------------------------------------------------------*/
    const { activeUser, drawerToggle } = useAuth();
    const isPatient = activeUser?.role === 'patient';
    const needsVerify = isPatient && activeUser?.isContactVerified === false;
    const canReviewVisits = ['admin', 'doctor', 'assistant'].includes(activeUser?.role);

    /* EVENT LISTENERS
    -------------------------------------------------------------------------------------*/

    /* ASYNC FUNCTIONS
    -------------------------------------------------------------------------------------*/

    /* EVENT FUNCTIONS
    -------------------------------------------------------------------------------------*/

    /* RENDER APP
    -------------------------------------------------------------------------------------*/
    return (
        <>
            <StyledList component="nav">
                {needsVerify ? (
                    <StyledListItem>
                        <StyledLink
                            button
                            onClick={() => drawerToggle()}
                            component={NavLink}
                            to="/verify"
                            end
                        >
                            <StyledIcon>
                                <VisitIcon />
                            </StyledIcon>
                            <StyledText disableTypography>Verify contact</StyledText>
                        </StyledLink>
                    </StyledListItem>
                ) : null}
                {isPatient && !needsVerify ? (
                    <>
                    <StyledListItem>
                        <StyledLink
                            button
                            onClick={() => drawerToggle()}
                            component={NavLink}
                            to="/my-visits"
                            end
                        >
                            <StyledIcon>
                                <VisitIcon />
                            </StyledIcon>
                            <StyledText disableTypography>My visits</StyledText>
                        </StyledLink>
                    </StyledListItem>
                    <StyledListItem>
                        <StyledLink
                            button
                            onClick={() => drawerToggle()}
                            component={NavLink}
                            to="/my-history"
                            end
                        >
                            <StyledIcon>
                                <ReportsIcon />
                            </StyledIcon>
                            <StyledText disableTypography>My history</StyledText>
                        </StyledLink>
                    </StyledListItem>
                    </>
                ) : null}
                {!isPatient ? (
                <>
                <StyledListItem>
                    <StyledLink
                        button
                        onClick={() => drawerToggle()}
                        component={NavLink}
                        to="/dashboard"
                        end
                    >
                        <StyledIcon>
                            <DashboardIcon />
                        </StyledIcon>
                        <StyledText disableTypography>Dashboard</StyledText>
                    </StyledLink>
                </StyledListItem>
                <StyledListItem>
                    <StyledLink
                        button
                        onClick={() => drawerToggle()}
                        component={NavLink}
                        to="/patients"
                        end
                    >
                        <StyledIcon>
                            <PeopleIcon />
                        </StyledIcon>
                        <StyledText disableTypography>Patients</StyledText>
                    </StyledLink>
                </StyledListItem>
                <StyledListItem>
                    <StyledLink
                        button
                        onClick={() => drawerToggle()}
                        component={NavLink}
                        to="/visit-history"
                        end
                    >
                        <StyledIcon>
                            <ReportsIcon />
                        </StyledIcon>
                        <StyledText disableTypography>Appointments</StyledText>
                    </StyledLink>
                </StyledListItem>
                <StyledListItem>
                    <StyledLink
                        button
                        onClick={() => drawerToggle()}
                        component={NavLink}
                        to="/follow-ups"
                        end
                    >
                        <StyledIcon>
                            <FollowUpIcon />
                        </StyledIcon>
                        <StyledText disableTypography>Follow-ups</StyledText>
                    </StyledLink>
                </StyledListItem>
                <StyledListItem>
                    <StyledLink
                        button
                        onClick={() => drawerToggle()}
                        component={NavLink}
                        to="/issues?status=Open"
                        end
                    >
                        <StyledIcon>
                            <IssueIcon />
                        </StyledIcon>
                        <StyledText disableTypography>Open issues</StyledText>
                    </StyledLink>
                </StyledListItem>
                <StyledListItem>
                    <StyledLink
                        button
                        onClick={() => drawerToggle()}
                        component={NavLink}
                        to="/visit-requests"
                        end
                    >
                        <StyledIcon>
                            <VisitIcon />
                        </StyledIcon>
                        <StyledText disableTypography>Visit requests</StyledText>
                    </StyledLink>
                </StyledListItem>
                {canReviewVisits ? (
                <StyledListItem>
                    <StyledLink
                        button
                        onClick={() => drawerToggle()}
                        component={NavLink}
                        to="/notices"
                        end
                    >
                        <StyledIcon>
                            <NoticeIcon />
                        </StyledIcon>
                        <StyledText disableTypography>Notices</StyledText>
                    </StyledLink>
                </StyledListItem>
                ) : null}
                {canReviewVisits ? (
                <StyledListItem>
                    <StyledLink
                        button
                        onClick={() => drawerToggle()}
                        component={NavLink}
                        to="/availability"
                        end
                    >
                        <StyledIcon>
                            <HoursIcon />
                        </StyledIcon>
                        <StyledText disableTypography>Visit hours</StyledText>
                    </StyledLink>
                </StyledListItem>
                ) : null}
                {activeUser?.role === 'admin' && (
                    <StyledListItem>
                        <StyledLink
                            button
                            onClick={() => drawerToggle()}
                            component={NavLink}
                            to="/admin"
                            end
                        >
                            <StyledIcon>
                                <AdminIcon />
                            </StyledIcon>
                            <StyledText disableTypography>
                                Administration
                            </StyledText>
                        </StyledLink>
                    </StyledListItem>
                )}
                </>
                ) : null}
            </StyledList>
        </>
    );
}

export default DrawerList;
